import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlEndPoints } from '../config/end-points';
import { SkillData } from '../interfaces/profile.interfaces';
import { AnesthRating, Skill } from '../models/skill.model';

@Injectable({
  providedIn: 'root',
})
export class SkillDal {
  constructor(private httpClient: HttpClient) {}

  getSkillsOfNurse(nurseId: string) {
    return this.httpClient.get<Skill[]>(`${urlEndPoints.skill}/by/profile/${nurseId}`);
  }

  getSkillHistoryAndSkill(profileId: string, specialty: string, role: string) {
    return this.httpClient.get(
      `${urlEndPoints.skills}get?profile=` + profileId + '&specialty=' + specialty + '&role=' + role
    );
  }

  getManySkillOfNurses(nursesIds: string[], specialesIds: string[]): Observable<Skill[]> {
    return this.httpClient.post<Skill[]>(urlEndPoints.skill + '/of-many/nurses', {
      nurses: nursesIds,
      specialties: specialesIds,
    });
  }

  getNurseRating(profilId: string, hospital: string, date: string, vacationsId: string[]): Observable<any> {
    return this.httpClient.post<any>(urlEndPoints.skill + '/getNurseRating', {
      profile: profilId,
      hospital: hospital,
      date: date,
      vacations: vacationsId,
    });
  }

  getAllRatings(date: string): Observable<any> {
    return this.httpClient.post<any>(urlEndPoints.skill + '/getAllRatings', {
      date: date,
    });
  }

  getAnesthRating(
    profilId: string,
    hospital: string,
    type: string,
    date: string,
    vacationsId: string[],
    specialty?: string
  ): Observable<AnesthRating> {
    return this.httpClient.post<any>(urlEndPoints.skill + '/getAnesthRating', {
      profile: profilId,
      hospital: hospital,
      date: date,
      type: type,
      vacations: vacationsId,
      specialty: specialty,
    });
  }

  getAllAnesthRatings(date: string): Observable<AnesthRating[]> {
    return this.httpClient.post<any>(urlEndPoints.skill + '/getAllAnesthRatings', {
      date: date,
    });
  }

  getSkillsOfProfileForHospitalFromOtherHospitals(profileId: string, hospitalId: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${urlEndPoints.skill}/getSkillsOfProfileForHospitalFromOtherHospitals?profile=` +
        profileId +
        '&hospital=' +
        hospitalId
    );
  }

  updateSkills(skillsList: any): Observable<any> {
    return this.httpClient.put<any>(`${urlEndPoints.skill}/manySkills`, skillsList);
  }

  initNursesSkills(skills: SkillData[]): Observable<any> {
    return this.httpClient.put<any[]>(`${urlEndPoints.skill}/initNursesSkills`, skills);
  }

  getNursesSkills(page: number, limit: number, data: any, search: string = ''): Observable<any> {
    return this.httpClient.post<any[]>(
      `${urlEndPoints.skill}/getNursesSkills?page=${page}&limit=${limit}&search=${search}`,
      data
    );
  }

  exportSkills(data: any): Observable<any> {
    return this.httpClient.post<any[]>(`${urlEndPoints.skill}/exportSkills`, data);
  }
}
